export const getLob = (selectedProduct) => {
    switch (selectedProduct) {
        case 'Renters':
            return 'Renter';
        case 'Auto+Renters':
            return 'Auto,Renter';
        case 'Auto+Home':
            return 'Auto,Home';
        case 'Auto+Condo':
            return 'Auto,Condo';
        default:
            return selectedProduct;
    }
}